import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import { SiteShape, SitesResponseShape } from 'models/sites';

export const SitesApi = createApi({
  reducerPath: 'sitesApi',
  tagTypes: ['sites', 'site'],
  baseQuery,
  endpoints: (builder) => ({
    getSitesTableData: builder.query<SitesResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['sites'],
    }),
    getSite: builder.query<SiteShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['site'],
    }),
  }),
});

export const { useGetSitesTableDataQuery, useGetSiteQuery } = SitesApi;
